import { render, staticRenderFns } from "./LessonView.vue?vue&type=template&id=3f835e0c&scoped=true"
import script from "./LessonView.vue?vue&type=script&lang=js"
export * from "./LessonView.vue?vue&type=script&lang=js"
import style0 from "./LessonView.vue?vue&type=style&index=0&id=3f835e0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f835e0c",
  null
  
)

export default component.exports